module.exports = __webpack_public_path__ + "static/media/doc-2.c4f20f38.jpg";